var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.title,
        width: "400px",
        visible: _vm.visible,
        "append-to-body": _vm.appendToBody,
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
      },
    },
    [
      _c(
        "el-upload",
        {
          staticClass: "upload-demo",
          staticStyle: { "text-align": "center" },
          attrs: {
            drag: "",
            action: "null",
            "http-request": _vm.handleUpload,
            limit: 1,
            "file-list": _vm.fileList,
            accept: _vm.accept,
          },
        },
        [
          _c("i", { staticClass: "el-icon-upload" }),
          _c("div", { staticClass: "el-upload__text" }, [
            _vm._v("将文件拖到此处，或"),
            _c("em", [_vm._v("点击上传")]),
          ]),
          _c(
            "div",
            {
              staticClass: "el-upload__tip",
              attrs: { slot: "tip" },
              slot: "tip",
            },
            [_vm._v("( " + _vm._s(_vm.tips) + " )")]
          ),
          _vm.enableDownloadTemplate
            ? _c(
                "div",
                {
                  staticClass: "el-upload__tip",
                  attrs: { slot: "tip" },
                  slot: "tip",
                },
                [
                  _vm._v(" 为保证数据导入顺利，推荐您使用: "),
                  _c(
                    "el-link",
                    {
                      staticStyle: { "font-size": "12px" },
                      attrs: { type: "primary" },
                      on: { click: _vm.handleDownload },
                    },
                    [_vm._v(" 下载模板 ")]
                  ),
                ],
                1
              )
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }